import React, { useEffect, useState } from 'react';

import { Box } from '@wds/box';
import { InputGroup } from '@wds/input-group';
import { InputMessage } from '@wds/input-message';
import { Select } from '@wds/select';

import PropTypes from 'prop-types';
import getComponentWithTheme from '../../../../themeProvider';
import { STRINGS } from './constants';

const DropdownCustomField = (props) => {
	const {
		id, label, value, onChange, required, readOnly, errors, setErrors, helperText, choices, settings,
	} = props;
	const [state, setState] = useState(value);
	const [error, setError] = useState('');

	useEffect(() => {
		if (value && value.length > 0) {
			validateField(value);
		}
	}, []);

	useEffect(() => {
		if (errors?.[id]) {
			setError(errors[id]);
		} else {
			setError('');
		}
	}, [errors]);

	const selectOptions = [
		<Select.Option key={`${id}-placeholder`} id='--' value='--'>{gettext('Please select...')}</Select.Option>,
		...choices?.map((choice) => (
			<Select.Option key={choice.id} id={choice.id} value={choice.value}>{choice.label}</Select.Option>
		)),
	];

	const validateField = (updatedValue) => {
		setState(updatedValue);
		const errorResult = settings.validator(updatedValue, choices.map((choice) => choice.value));
		if ((!required && errorResult && updatedValue !== '--') || (required && errorResult)) {
			setErrors({ ...errors, [id]: errorResult });
		} else {
			setErrors((prevErrors) => {
				const { [id]: _, ...rest } = prevErrors;
				return rest;
			});
			onChange(updatedValue);
		}
	};

	const handleChange = (e) => {
		validateField(e.target.value);
	};

	return (
		getComponentWithTheme(
			<Box>
				<InputGroup
					id={`${id}-input-group`}
					label={`${label} ${required ? '' : `(${STRINGS.optional})`}`}
					required={required}
					color={errors?.[id] ? 'error' : undefined}
					disabled={readOnly}
					stretched
				>
					<Select value={state} id={id} onChange={handleChange} stretched>
						{selectOptions}
					</Select>
				</InputGroup>
				{helperText && <InputMessage id={`${id}-helper-text`}>{helperText}</InputMessage>}
				{errors?.[id] && <InputMessage color='error' id={`${id}-error-text`}>{error}</InputMessage>}
			</Box>,
		)
	);
};

export default DropdownCustomField;
DropdownCustomField.propTypes = {
	choices: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number.isRequired,
		value: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
	})),
	id: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool.isRequired,
	readOnly: PropTypes.bool,
	value: PropTypes.string,
	errors: PropTypes.object,
	helperText: PropTypes.string,
	addOn: PropTypes.node,
};
DropdownCustomField.defaultProps = {
	choices: [],
	value: '',
	readOnly: false,
	errors: {},
	helperText: '',
	addOn: null,
};
